export default __webpack_public_path__ + "static/media/female_aorta-01.64c2a262.png";